export default "__VITE_ASSET__33d05176__"